import { useHistory } from 'react-router';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { UserLogoutResponseBody } from '../types/generated/logout_post.response';
import { useTranslate } from '../../hooks/context/useTranslate';
import { useDatasetSessionStorageContext } from '../../hooks/context/useDatasetSessionStorageContext';
import useRoutes from '../../hooks/useRoutes';
import { requestLogout } from '../requests/requestLogout';
import { useStart } from './useStart';
import { LOG_OUT } from '../../constants';
import toast from 'react-hot-toast';

export const useLogout = () => {
  const [isPending, setIsPending] = useState<boolean>(false);

  const {
    state: { token },
    dispatch,
  } = useUserState();
  const { t } = useTranslate();
  const history = useHistory();
  const { start } = useStart();
  const { setDatasetSessionStorageState } = useDatasetSessionStorageContext();
  const routes = useRoutes();

  const { error, mutateAsync: logout } = useMutation<
    UserLogoutResponseBody,
    Error
  >({
    mutationFn: () => {
      setIsPending(true);
      return requestLogout(token);
    },
    onSuccess: async (data) => {
      if (data.success) {
        dispatch({ type: LOG_OUT });
        // The side-menu search + its one-shot scroll intent must not survive a logout.
        setDatasetSessionStorageState({
          menuSearch: undefined,
          menuScrollCenterOnce: undefined,
        });
        await start();
        setIsPending(false);
        history.push(routes.home());
      } else {
        setIsPending(false);
        toast(t('toasts.failedLogout'));
      }
    },
    onError: () => {
      setIsPending(false);
    },
  });

  return { isPending, error, logout };
};
